import { Box, Stack, Typography } from '@mui/material';
import { LinkArrowLeft2 } from 'Components';
import { ChipStepper } from 'Components/ChipStepper';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useNavigate, useLocation } from 'react-router';

interface IStageAndMoreInfo {
  stepsAmount: number;
  currentStep: number;
  claimEventNumber: string | undefined;
}
export const StageAndMoreInfo = ({
  stepsAmount,
  currentStep,
  claimEventNumber,
}: IStageAndMoreInfo) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Status);
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <Stack
      direction={isDesktop ? 'row' : 'column'}
      justifyContent='space-between'
      alignItems={isDesktop ? 'flex-end' : undefined}
    >
      <Stack width='fit-content' rowGap={isDesktop ? '16px' : '12px'}>
        <Typography variant='body5'>{dictionary.dialogSubTitle}</Typography>
        <ChipStepper steps={stepsAmount} activeStep={currentStep} />
      </Stack>
      <Box
        sx={
          isDesktop
            ? {}
            : {
                bgcolor: 'primary.shade_100',
                position: 'absolute',
                bottom: 0,
                right: 0,
                width: '100%',
                height: '42px',
                pr: '24px',
                borderRadius: '0 0 16px 16px',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
              }
        }
        onClick={() =>
          navigate(
            pathname === '/'
              ? `recognitionStatus/${claimEventNumber}`
              : `${claimEventNumber}`
          )
        }
      >
        <LinkArrowLeft2 text={dictionary.moreInfo} href='' newWindow={false} />
      </Box>
    </Stack>
  );
};
